import { render, staticRenderFns } from "./inspectionTasks.vue?vue&type=template&id=231417d4&scoped=true"
import script from "./inspectionTasks.vue?vue&type=script&lang=js"
export * from "./inspectionTasks.vue?vue&type=script&lang=js"
import style0 from "./inspectionTasks.vue?vue&type=style&index=0&id=231417d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231417d4",
  null
  
)

export default component.exports